import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/MehrsanOperations"
    : "SLN/SolarentOperator/MehrsanOperations";

const MehrsanOperationsApi = {
  getAssigneeOptions: async (source) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetAssigneeOptions`
    ),

  getByRequestId: async (source, requestInfoId) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetByRequestId/${requestInfoId}`
    ),

  getById: async (source, id) =>
    DefaultApiService.getCustomeApi(`${baseBySource(source)}/GetById/${id}`),

  create: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Create`, data),

  update: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Update`, data),

  addLog: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/AddLog`, data),

  complete: async (source, processId) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Complete/${processId}`),

  softDelete: async (source, processId) =>
    DefaultApiService.postApi(`${baseBySource(source)}/SoftDelete/${processId}`),
};

export default MehrsanOperationsApi;
